import styled, { css } from 'styled-components';

export const MatchRowWrapper = styled.div`
  position: relative;
  background-color: #fff;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-right: 9px;
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    margin-right: 10px;
    .generalBackground {
      height: 20px;
    }
  };   
  .boxTeam {
    flex: ${props => (props.isMobile ? '0' : '3')};
    line-height: 1;
    width: ${props => (props.isMobile ? 'auto' : '50%')};
  }
`;

export const MatchRowDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3px;
  height: 33px;
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    height: 29px;
    margin-top: 11px;
  };
`;

export const MatchRowWrapperInt = styled.div`
  box-sizing: border-box;
  width: ${props => (props.isGazzanet ? '140px' : '145px')};
  height: 90px;
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    width: ${props => (props.isGazzanet ? '120px' : '145px')};
    height: 150px;
  };
  box-shadow: 0px 0px 4px 0 rgba(0,0,0,0.4);
  border-radius: 4px;
  overflow: hidden;
`;

export const GroupCircle = styled.div`
  position: absolute;
  background-color: orange;
  border: 1px solid orange;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    height: 25px;
    width: 25px;
  }
  font-size: 9px;
  z-index: 30;
  top: 14px;
  right: 2px
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre-line;
  word-spacing: 11px;
  cursor: default;
  color: black;
  text-decoration: none;
  margin-top: -20px;
  font-family: ${props => props.theme.fontSets.BreraRegular};
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    right: 5px;
    top: -4px;
    margin-top: 0px;    
  };
`;

export const MatchLinkWrapper = styled.a`
  ${props => props.disableLink && css`
    pointer-events: none !important;
    cursor: default !important;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/MatchRowBoxed/styles.js